/**
* @Description 文件功能说明：上传预览弹窗
* @Author 张彬
* @Time 2021/3/13 11:33
**/

/* HTML */
<template>
    <div v-if="dialogTreeItem.dialogFormVisible">
        <el-dialog :title="dialogTreeItem.title"
                   :visible.sync="dialogTreeItem.dialogFormVisible"
                   :close-on-click-modal="false"
                   custom-class="form-dialog"
                   v-dialogDrag
                   class="dialog_title"
                   @close="handleDialogClose"
        >
            <!-- 表格 -->
            <DynamicTable ref="dynamicTable"
                          :previewTitle="upload.previewTitle"
                          :previewData="searchResult"
                          :selectBox="true"
                          :optionButton="false"
                          @selectRow="selectRow"
                          @selectRows="selectRows"
                          :key="dynamicTableKey"
                          :showSerialNumber="upload.showSerialNumber"
            />

            <el-form v-if="dialogTreeItem.submitButton != ''" style="margin-bottom: 10px;">
                <el-form-item>
                    <div><span>已选中 </span><span style="font-weight: bold;">{{selectIds.length}}</span> <span>个</span></div>
                    <div v-if="selectIds.length>0"><span style="font-weight: bold;">选中：{{selectIds}}</span></div>
                </el-form-item>
            </el-form>

            <el-form :inline="true" :model="searchForm" ref="searchForm" :rules="rules">
                <el-form-item label="有效测距个数："prop="rangeNum">
                    <el-input v-model="searchForm.rangeNum" type="number" min="5" size="mini"/>
                </el-form-item>
                <el-form-item label="基站间的测距误差：" prop="rangeError">
                    <el-input v-model="searchForm.rangeError" size="mini" style="padding-top: 5px;">
                        <template slot="append">米</template>
                    </el-input>
                </el-form-item>
                <el-form-item style="float: right; ">
                    <el-button type="primary" @click.native="submit" >{{dialogTreeItem.submitButton}}</el-button>
                </el-form-item>
            </el-form>

        </el-dialog>
    </div>

</template>

/* JS */
<script>

import DynamicTable from '@/components/DynamicTable.vue'
import ApiOam from "@/request/api-oam";
import GlobalParam from "@/global/global-param";

export default {

    /**
     * @Des 组件名
     * @Auth Zhangbin
     * @Date 17:22 2021/4/30
     */
    name: 'UwbBSRangeAddDialog',

    /**
     * @Des 组件引用
     * @Auth Zhangbin
     * @Date 17:22 2021/4/30
     */
    components: {
        // 动态表格
        DynamicTable
    },

    /**
     * @Des 数据定义
     * @Auth Zhangbin
     * @Date 17:23 2021/4/30
     */
    data() {
        return{

            /**
             * @Des 弹出层属性
             * @Auth Zhangbin
             * @Date 17:23 2021/4/30
             */
            dialogTreeItem: {
                title: '',
                dialogFormVisible: false,
                submitButton: '',
            },
            // 动态表格
            dynamicTableKey: 0,
            // 上传数据集合
            uploadData: [],
            // 选择的数量
            selectNum: 0,
            // 查询表单
            searchForm:{
                keyword: "",
                projectId: this.$store.state.currentProjectId,
                rangeNum: 20,
                rangeError: 1
            },
            // 查询结果
            searchResult: [],
            selectIds: [],
            operationLock: false,
            selectProjectId: '',
            /**
             * @Des 上传属性
             * @Auth Zhangbin
             * @Date 17:17 2021/4/30
             */
            upload:{
                previewTitle: [],
                previewData: [],
                searchBsUrl: ApiOam.Find_Uwb_Bs_By_ProjectId_Uri ,
                addRangeBsUrl: ApiOam.Add_Uwb_Range_Bs_Uri ,
                showSerialNumber: true
            },
            /**
             * 样式修改
             * */
            surroundSpan(value) {
                return '<span style="white-space: nowrap;" title="'+ value +'">'+ value +'</span>';
            },
            rules: {
                rangeNum: [
                    {
                        validator: (rule, value, callback) => {
                            if(value == ''){
                                this.searchForm.rangeNum = 60;
                            }else{
                                if(value < 1){
                                    this.searchForm.rangeNum = 1;
                                }else if(value > 300){
                                    this.searchForm.rangeNum = 300;
                                }
                            }
                            callback();
                        },
                        trigger: "blur"
                    }
                ],
                rangeError: [
                    {
                        validator: (rule, value, callback) => {
                            if(value == ''){
                                this.searchForm.rangeError = 1;
                            }
                            callback();
                        },
                        trigger: "blur"
                    }
                ]

            }
        }
    },
    /**
     * @Des 方法定义
     * @Auth Zhangbin
     * @Date 17:24 2021/4/30
     */
    methods: {

        /**
         * 筛选查询
         * */
        search(){
            this.selectNum = 0;
            this.searchResult = [];
            if(this.searchForm.keyword == ''){
                this.searchResult = Object.assign([], this.upload.previewData);
            }else{
                this.upload.previewData.forEach((row, index) => {
                    if(row.bsId.indexOf(this.searchForm.keyword) != -1
                        || row.sid == this.searchForm.keyword
                        || row.localAddress.indexOf(this.searchForm.keyword) != -1
                    ){
                        if(this.selectIds.indexOf(row.id) == -1){
                            row.checked = false;
                        }else{
                            row.checked = true;
                        }
                        this.searchResult.push(row);
                    }
                })
            }
            this.dynamicTableKey++;
        },

        /**
         * @Des 打开弹窗
         * @Auth Zhangbin
         * @Date 17:24 2021/4/30
         */
        openDialog(title, button){
            this.dialogTreeItem.title = title;
            this.dialogTreeItem.dialogFormVisible = true;
            this.dialogTreeItem.submitButton = button;
            this.searchResult = [];
            this.selectIds = [];
            this.$nextTick(() => {
                this.searchResult = Object.assign([], this.previewData);
                this.$refs.dynamicTable.cleanSelect();
            })
            this.addTitle();
            this.changeProject();
        },

        /**
         * @Des 关闭弹窗
         * @Auth Zhangbin
         * @Date 17:24 2021/4/30
         */
        handleDialogClose(){
            this.$refs.dynamicTable.cleanSelect();
            this.dialogTreeItem.dialogFormVisible = false;
            this.$emit("research");
        },


        /**
         * @Des 选择行处理
         * @Auth Zhangbin
         * @Date 17:24 2021/4/30
         */
        selectRow(row, selection){
            // console.log(row, selection)
            this.selectNum = selection.length;
            this.resetSelectId(selection);
        },

        /**
         * @Des 选择多行处理
         * @Auth Zhangbin
         * @Date 17:24 2021/4/30
         */
        selectRows(rows){
            // console.log(rows);
            this.selectNum = rows.length;
            this.resetSelectId(rows);
        },

        /**
         * 重置选中的id
         * */
        resetSelectId(rows){
            // console.log(rows);
            // 新增id
            this.searchResult.forEach((r,i) => {
                let exist = false;
                rows.forEach((r2, i2) => {
                    if(r2.id == r.id){
                        exist = true;
                        if(this.selectIds.indexOf(r.id) == -1){
                            this.selectIds.push(r.id);
                            r.checked = true;
                        }
                    }
                });
                if(!exist){
                    if(this.selectIds.indexOf(r.id) != -1){
                        this.selectIds.splice(this.selectIds.indexOf(r.id),1);
                        r.checked = false;
                    }
                }
            })
        },

        /**
         * @Des 数据提交
         * @Auth Zhangbin
         * @Date 17:49 2021/4/30
         */
        submit(){
            if(this.selectIds.length == 0){
                this.$message({
                    message: '请选择数据',
                    type: 'info',
                    showClose: true,
                    dangerouslyUseHTMLString: true
                });
                return false;
            }

            this.operationLock = true;
            this.$request.postJsonRequest(this.upload.addRangeBsUrl, {
                bsSids: this.selectIds,
                projectId: this.$store.state.currentProjectId,
                rangeNum: this.searchForm.rangeNum,
                rangeError: this.searchForm.rangeError
            }).then(result => {
                if(result.code == 0){
                    this.$message({
                        message: '添加成功',
                        type: 'success',
                        showClose: true,
                        dangerouslyUseHTMLString: true
                    });
                    this.handleDialogClose();
                    this.$emit("research");
                }else{
                    this.$message({
                        message: result.msg,
                        type: 'error',
                        showClose: true,
                        dangerouslyUseHTMLString: true
                    });
                }
                this.operationLock = false;
            }).catch(error => {
            	this.operationLock = false;
            	console.error('添加测距基站异常', this.upload.addRangeBsUrl, error);
            });
        },
        /**
         * @Author ZhangBin
         * @Description //TODO 改变项目
         * @Date 11:54 2022/5/18
         * @Param
         * @return
         **/
        changeProject(){
            this.$request.postJsonRequest(ApiOam.Find_Uwb_Bs_By_ProjectId_Uri, {
                projectId: this.searchForm.projectId,
                unRange: true
            }).then(result => {
                // console.log(result.data);
                this.upload.previewData = [];
                if(result.code == 0 && result.data){
                    result.data.forEach((row, index) => {
                        let _row = {
                            id: row.sid,
                            bsSerial: row.bsSerial,
                            bsId: row.bsId,
                            sid: row.sid,
                            localAddress: row.localAddress,
                            subnetMask: row.subnetMask,
                            gatewayAddress: row.gatewayAddress,
                            channelNumber: row.channelNumber,
                            timeSlot: row.timeSlot,
                            status: row.status,
                            statusName: GlobalParam.bsStatus[row.status],
                            disabled: false,
                            checked: false,
                        }
                        let _row_ = {};
                        for (let i in _row) {
                            // 外围添加 span
                            _row_[i + 'Span'] = this.surroundSpan(_row[i]==null?"":_row[i]);
                        };

                        this.upload.previewData.push(Object.assign({}, _row, _row_));
                    })
                    this.search();
                }else{
                    this.$message({
                        message: result.msg,
                        type: 'error',
                        showClose: true,
                        dangerouslyUseHTMLString: true
                    });
                }
            }).catch(error => {
                console.error('查询基站异常', ApiOam.Find_Uwb_Bs_By_ProjectId_Uri, error);
            })
        },

        addTitle(){
            this.upload.previewTitle = [];
            // 显示基站列表信息
            this.upload.previewTitle.push({
                label: '基站编号',
                prop: 'bsId',
            });
            this.upload.previewTitle.push({
                label: '序列号',
                prop: 'sid',
            });
            this.upload.previewTitle.push({
                label: '安装序号',
                prop: 'bsSerial',
            });
            this.upload.previewTitle.push({
                label: '基站地址',
                prop: 'localAddress',
            });
            this.upload.previewTitle.push({
                label: '状态',
                prop: 'statusName',
            });
        }
    },

}
</script>

/* CSS */
<style lang="scss" scoped>
	/deep/ .el-dialog {
		width: 90%;
	}
	/deep/ .form-dialog .el-select {
		width: auto;
	}
	/deep/ .form-dialog .el-form,
	/deep/ .form-dialog .el-form-item {
		margin-bottom: 0px;
	}

    /deep/ .el-input .el-input__inner{
        width: 80px;
    }

    /deep/ .el-select .el-input__inner{
        width: 250px;
    }


</style>



// WEBPACK FOOTER //
// src/components_pages/Device/UwbBSRangeAddDialog.vue